import React, { useState } from 'react';
import { Button, Typography, Alert } from '@mui/material';
import { auth } from '../../firebase/firebase';
import { sendEmailVerification } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const VerifyEmail = () => {
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const resendVerification = async () => {
    if (auth.currentUser) {
      await sendEmailVerification(auth.currentUser);
      setMessage('Verification email sent.');
    }
  };

  const checkVerified = async () => {
    if (auth.currentUser) {
      await auth.currentUser.reload();
      if (auth.currentUser.emailVerified) {
        navigate('/dashboard');
      } else {
        setMessage('Email not verified yet.');
      }
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: 'auto', padding: '20px' }}>
      <Typography variant="h5" align="center" gutterBottom>
        Verify Your Email
      </Typography>
      <Typography align="center">
        Please check your inbox for a verification link to activate your account.
      </Typography>
      {message && (
        <Alert severity="info" sx={{ mt: 2 }}>
          {message}
        </Alert>
      )}
      <Button fullWidth variant="contained" sx={{ mt: 3 }} onClick={resendVerification}>
        Resend Verification Email
      </Button>
      <Button fullWidth sx={{ mt: 2 }} onClick={checkVerified}>
        I've Verified My Email
      </Button>
    </div>
  );
};

export default VerifyEmail;
